import { render, staticRenderFns } from "./TariffCard.vue?vue&type=template&id=390923ee&scoped=true"
import script from "./TariffCard.vue?vue&type=script&lang=ts"
export * from "./TariffCard.vue?vue&type=script&lang=ts"
import style0 from "./TariffCard.vue?vue&type=style&index=0&id=390923ee&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390923ee",
  null
  
)

export default component.exports